module.exports = __webpack_public_path__ + "media/images/smart_phone/rank/icon_rank2-af3f12df380cd86fc5bc6d9242ae335d.png";